/**
 * String lookup.
 *
 * All four dictionaries are typed against the English one, so a missing or misspelled key
 * in a translation is a compile error rather than a blank space on a live page.
 */

import { DEFAULT_LOCALE, type Locale } from './locales.js';
import { en, type Strings } from './strings.en.js';
import { es } from './strings.es.js';
import { fr } from './strings.fr.js';
import { pt } from './strings.pt.js';

const LOCALES: Record<Locale, Strings> = { en, fr, es, pt };

export function getStrings(locale: Locale = DEFAULT_LOCALE): Strings {
  return LOCALES[locale];
}

export { DEFAULT_LOCALE };
export type { Strings, Locale };
